import { render, staticRenderFns } from "./CreateAction.vue?vue&type=template&id=3cffbef4&scoped=true&"
import script from "./CreateAction.vue?vue&type=script&lang=js&"
export * from "./CreateAction.vue?vue&type=script&lang=js&"
import style0 from "./CreateAction.vue?vue&type=style&index=0&id=3cffbef4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cffbef4",
  null
  
)

export default component.exports